module.exports = __webpack_public_path__ + "eb3c4d398733f34d92c8b054a64a73ff.MP3";